"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _roleAuthority = require("@/api/authorityManagement/roleAuthority");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      queryData: {
        roleName: null,
        id: null,
        status: null,
        // 0-禁用 1-启用）
        page: {
          page: 1,
          size: 10
        }
      },
      tableData: [],
      total: 0,
      ControlsType: true,
      dialogVisible: false,
      ruleForm: {
        roleName: '',
        status: null,
        description: '',
        id: null
      },
      rules: {
        roleName: [{
          required: true,
          message: '请输入角色名称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 99,
          message: '长度在 1 到 99 个字符',
          trigger: 'blur'
        }],
        status: [{
          required: true,
          message: '请选择角色状态',
          trigger: 'change'
        }],
        description: [{
          required: true,
          message: '请输入角色描述',
          trigger: 'blur'
        }, {
          min: 1,
          max: 5000,
          message: '长度在 1 到 5000 个字符',
          trigger: 'blur'
        }]
      },
      // 角色授权
      charactersDialogVisible: false,
      checked: false,
      // 全部展开
      checked1: false,
      allTreeData: [],
      defaultProps: {
        children: 'children',
        label: 'title'
      },
      expandedKeys: [],
      charactersID: null,
      checkedKeys: [] // 默认选中的节点
    };
  },
  created: function created() {
    this.queryRolePage();
    this.queryAppAllPermission();
  },
  methods: {
    onInit: function onInit() {
      this.queryData = {
        roleName: null,
        id: null,
        status: null,
        page: {
          page: 1,
          size: 10
        }
      };
    },
    onInitRuleForm: function onInitRuleForm() {
      this.ruleForm = {
        roleName: '',
        status: null,
        description: '',
        id: null
      };
    },
    queryRolePage: function () {
      var _queryRolePage2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = (0, _objectSpread2.default)({
                appId: null
              }, this.queryData);
              _context.n = 1;
              return (0, _roleAuthority.queryRolePage)(params);
            case 1:
              res = _context.v;
              this.tableData = res.data.data;
              this.total = res.data.total;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function queryRolePage() {
        return _queryRolePage2.apply(this, arguments);
      }
      return queryRolePage;
    }(),
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.queryRolePage();
    },
    onInitialize: function onInitialize() {
      this.onInit();
      this.queryRolePage();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.queryRolePage();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.queryRolePage();
    },
    onAdd: function onAdd() {
      this.ControlsType = true;
      // this.resetForm('ruleForm')
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      this.resetForm('ruleForm');
      this.onInitRuleForm();
      this.dialogVisible = false;
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$confirm('是否确认角色添加/修改?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this.addOrUpdateRole();
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    addOrUpdateRole: function () {
      var _addOrUpdateRole2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context2.n = 1;
              return (0, _roleAuthority.addOrUpdateRole)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.resetForm('ruleForm');
                this.onClose();
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.onInitialize();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function addOrUpdateRole() {
        return _addOrUpdateRole2.apply(this, arguments);
      }
      return addOrUpdateRole;
    }(),
    onEditor: function onEditor(data) {
      this.ControlsType = false;
      this.ruleForm.roleName = data.roleName;
      this.ruleForm.status = data.status;
      this.ruleForm.description = data.description;
      this.ruleForm.id = data.id;
      this.dialogVisible = true;
    },
    onDel: function onDel(data) {
      var _this2 = this;
      this.$confirm('删除角色，绑定该角色的账户将会受到影响，导致无法使用角色涉及功能，确定还要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.deleteAdminRole(data.id);
      });
    },
    deleteAdminRole: function () {
      var _deleteAdminRole2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(id) {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                roleId: id
              };
              _context3.n = 1;
              return (0, _roleAuthority.deleteAdminRole)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.onInitialize();
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function deleteAdminRole(_x) {
        return _deleteAdminRole2.apply(this, arguments);
      }
      return deleteAdminRole;
    }(),
    // 授权
    // 打开
    onAccredit: function onAccredit(data) {
      this.charactersID = data.id;
      this.charactersDialogVisible = true;
      this.queryPermissionTreeByRoleId(data.id);
    },
    // 关闭
    onCharactersClose: function onCharactersClose() {
      this.checkedKeys = [];
      this.$refs.tree.setCheckedKeys([]);
      this.charactersDialogVisible = false;
    },
    // 超管所有路由
    queryAppAllPermission: function () {
      var _queryAppAllPermission2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = {};
              _context4.n = 1;
              return (0, _roleAuthority.queryAppAllPermission)(params);
            case 1:
              res = _context4.v;
              this.allTreeData = res.data;
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.log(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function queryAppAllPermission() {
        return _queryAppAllPermission2.apply(this, arguments);
      }
      return queryAppAllPermission;
    }(),
    // 当前角色的路由
    queryPermissionTreeByRoleId: function () {
      var _queryPermissionTreeByRoleId2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(roleId) {
        var _this3 = this;
        var params, res, _t5;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              params = {
                roleId: roleId
              };
              _context5.n = 1;
              return (0, _roleAuthority.queryPermissionTreeByRoleId)(params);
            case 1:
              res = _context5.v;
              this.onResetAccredit();
              this.checkedKeys = res.data;
              // this.expandedKeys = res.data
              this.$nextTick(function () {
                _this3.$refs.tree.setCheckedKeys(res.data);
              });
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t5 = _context5.v;
              console.log(_t5);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function queryPermissionTreeByRoleId(_x2) {
        return _queryPermissionTreeByRoleId2.apply(this, arguments);
      }
      return queryPermissionTreeByRoleId;
    }(),
    onVerifyAccredit: function onVerifyAccredit() {
      var _this4 = this;
      this.$confirm('是否确认授权菜单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.buildRolePermission();
      });
    },
    // 授权接口
    buildRolePermission: function () {
      var _buildRolePermission2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6() {
        var params, res, _t6;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              params = {
                roleId: this.charactersID,
                permissionIdList: this.$refs.tree.getCheckedKeys()
              };
              _context6.n = 1;
              return (0, _roleAuthority.buildRolePermission)(params);
            case 1:
              res = _context6.v;
              if (res.code === 0) {
                this.onCharactersClose();
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.queryRolePage();
                // await this.$store.dispatch('user/getInfo')
                // const accessRoutes = await this.$store.dispatch('permission/generateRoutes')
                // router.addRoutes(accessRoutes)
                this.$router.go(0);
              }
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t6 = _context6.v;
              console.log(_t6);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function buildRolePermission() {
        return _buildRolePermission2.apply(this, arguments);
      }
      return buildRolePermission;
    }(),
    onResetAccredit: function onResetAccredit() {
      var _this5 = this;
      this.checkedKeys = [];
      this.$nextTick(function () {
        _this5.$refs.tree.setCheckedKeys([]);
      });
    },
    // 全选，全不选
    onSelectAll: function onSelectAll(value) {
      if (value) {
        // const allIds = this.getAllIds(this.allTreeData)
        // this.$refs.tree.setCheckedKeys(allIds)
        // this.checkedIds = allIds
      } else {
        // console.log('取消全选')
        // this.onResetAccredit()
        // this.checkedIds = []
        // this.$refs.tree.setCheckedKeys([])
      }
    },
    // getAllIds(treeData) {
    //   let ids = []
    //   treeData.forEach(node => {
    //     ids.push(node.id)
    //     if (node.children && node.children.length > 0) {
    //       ids = ids.concat(this.getAllIds(node.children))
    //     }
    //   })
    //   return ids
    // },
    // 全部展开，全部收起----------------
    onUnfold: function onUnfold(value) {
      var tree = this.$refs.tree;
      if (value) {
        this.expandAllNodes(tree);
      } else {
        this.collapseAllNodes(tree);
      }
    },
    expandAllNodes: function expandAllNodes(tree) {
      var _expandNodes = function expandNodes(nodes) {
        nodes.forEach(function (node) {
          tree.store.nodesMap[node.id].expanded = true;
          if (node.children && node.children.length > 0) {
            _expandNodes(node.children);
          }
        });
      };
      _expandNodes(this.allTreeData);
    },
    collapseAllNodes: function collapseAllNodes(tree) {
      var _collapseNodes = function collapseNodes(nodes) {
        nodes.forEach(function (node) {
          tree.store.nodesMap[node.id].expanded = false;
          if (node.children && node.children.length > 0) {
            _collapseNodes(node.children);
          }
        });
      };
      _collapseNodes(this.allTreeData);
    }
  }
};